import { apiFetch } from "#lib/api";

interface ImportStatus {
  job_id: string;
  service: string;
  priority: number;
  sub_count: number;
  save_dms: boolean;
  created_at: string;
  first_started_at: string | null;
  retry_count: number;
  current_try_started_at: string | null;
  resuming_at: string | null;
  finished_at: string | null;
  is_key_invalid: boolean;
  key_failed_at: string | null;
  logs: Array<string>;
}

export async function fetchImport(importId: string): Promise<ImportStatus> {
  const path = `/imports/${importId}`;

  const result = await apiFetch<ImportStatus>(path, { method: "GET" });

  return result;
}
